import React from 'react';
import {asyncComponent} from 'react-async-component';
import SiteHeader from '@homeaway/react-site-header';

/* istanbul ignore next */
const AsyncSiteHeader = asyncComponent({
    name: 'AsyncSiteHeader',
    resolve: () => Promise.resolve(SiteHeader),
    serverMode: 'defer'
});

export default function AsyncHeader({header, isMobile, siteName, fullLocale, currency}) {
    return (
        <div className="site-header-container">
            <AsyncSiteHeader
                {...header}
                dataUrl="/traveler/scratchpad/api/header"
                isMobile={isMobile}
                siteName={siteName}
                fullLocale={fullLocale}
                currencyCode={currency}
                withoutCountryLanguageSelector={false}
                withoutCurrencySelector={false}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/universal/abacus/waterfall/async-header.js